
// ============================================
// NewsDetailScene - ニュース詳細ページシーン
// ============================================

/**
 * GNS.NewsDetailScene
 * * ニュース詳細ページのメイン制御クラス
 * * 主な機能:
 * - ニュース詳細の表示制御
 * - ページ下部の関連ニュースリストのインタラクション制御
 * (左側の矢印リンクと右側の記事ボックスの連動)
 */
GNS.NewsDetailScene = function (GNS) {
    // AbstractSceneを継承
    const scene = GNS.create(GNS.AbstractScene);

    /**
     * 初期化処理
     */
    scene.init = function (data) {
        scene._super.init.call(this, data);

        // インタラクションボタン管理用配列
        this.buttons = []; // 旧 playerArray

        // トップ画像（元コードにありましたが、以降のロジックでは未使用のようです）
        this.topImage = new GNS.DisplayObject("casesdetail__container__title__img");
    };

    /**
     * ロード処理
     */
    scene.load = function () {
        this.isLoading = true;
        this._loadComplete();
    };

    /**
     * ロード完了時の処理
     * 関連ニュースリストのDOM要素を取得し、インタラクションを設定する
     */
    scene._bind._loadComplete = function () {
        // 矢印リンクのコンテナを取得
        const arrowContainers = this.element.querySelectorAll(".news__container__line__arror");

        if (arrowContainers.length > 0) {
            // 1. 矢印リンクのリスト (左側)
            const arrowLinks = arrowContainers[0].querySelectorAll(".item__link");

            // 2. 記事ボックスのリスト (右側)
            const newsBoxes = this.element.querySelectorAll(".news__container__line__box");

            // リストを走査してボタン化
            // (矢印リンクの数と記事ボックスの数は一致している前提)
            for (let i = 0; i < newsBoxes.length; i++) {
                const arrowLinkEl = arrowLinks[i];
                const boxEl = newsBoxes[i];

                // 必須要素がない場合はスキップ
                if (!arrowLinkEl || !boxEl) continue;

                // ボックス内の画像を取得
                let imgObj = null;
                const imgContainer = boxEl.querySelector(".news__container__line__box__column__img");
                if (imgContainer) {
                    const imgTag = imgContainer.querySelector("img");
                    if (imgTag) {
                        imgObj = new GNS.DisplayObject(imgTag);
                    }
                }

                // ボックス自体のDisplayObject
                const boxObj = new GNS.DisplayObject(boxEl);

                // UIThumBtnの生成
                // 左側の矢印(arrowLinkEl)にマウスオーバーすると、右側の画像(imgObj)が反応する
                const btn = new GNS.UIThumBtn(
                    arrowLinkEl, // トリガーとなるDOM
                    null,        // 背景要素 (今回はnull)
                    imgObj,      // アニメーションさせる画像
                    boxObj,      // アニメーションさせるコンテナ
                    null,        // 追加の連動リンク (WhoWeAreDetailSceneとは異なり、ここはnull)
                    0.05 * i     // アニメーション遅延
                );

                this.buttons.push(btn);
            }
        }

        // 親クラスのロード完了処理
        scene._super.load.call(this);
    };

    /**
     * 表示ハンドラ
     */
    scene.showHandler = function () {
        // 実装なし
    };

    /**
     * 非表示ハンドラ
     */
    scene.hideHandler = function () {
        // 実装なし
    };

    /**
     * リセットハンドラ
     * 生成したボタンインスタンスを破棄
     */
    scene.resetHandler = function () {
        this.buttons.forEach(btn => {
            if (btn.kill) btn.kill();
        });
        this.buttons = [];
    };

    return scene._self;
}(GNS);
